import { queryOptions, useQuery } from "@tanstack/react-query";

import data from "../../assets/mocks/market-top-performing.json";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";
import { AxiosMock } from "@/utils/mock";

import type { QueryConfig } from "@/lib/react-query";
import type { MarketCar } from "@/types/market";

if (import.meta.env.MODE === "test") {
  // Mocking the API response for watchlists
  const mock = AxiosMock.getInstance();
  const uri = new RegExp("/carburate/market/makes/.+/top_performing/");
  mock.onGet(uri).reply(200, data);
}

export const getMarketMakeTopPerforming = ({ makeId }: { makeId: string }) => {
  return api.get(`/carburate/market/makes/${makeId}/top_performing/`) as Promise<MarketCar[]>;
};

export const getMarketMakeTopPerformingQueryOptions = (makeId: string) => {
  return queryOptions({
    queryKey: ["market", "makes", makeId, "top-performing"],
    queryFn: () => getMarketMakeTopPerforming({ makeId }),
  });
};

type UseMarketMakeTopPerformingOptions = {
  makeId: string;
  queryConfig?: QueryConfig<typeof getMarketMakeTopPerforming>;
};

export const useMarketMakeTopPerforming = ({
  makeId,
  queryConfig,
}: UseMarketMakeTopPerformingOptions) => {
  return useQuery({
    enabled: hasAccessToken(),
    ...getMarketMakeTopPerformingQueryOptions(makeId),
    ...queryConfig,
  });
};
